import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Checkout from './Checkout';
import Login from './Login';
import SignUp from './SignUp';
import { UserAuthContextProvider } from './UserAuthContext';
import ProtectedRoute from './ProtectedRoute';
import Payment from './Payment';


function App() {

  return (
    <div className="App">
      <BrowserRouter>
      <UserAuthContextProvider>
      <Routes>
      <Route path = "/signup" element = {<SignUp/>}/>
      <Route path = "/"  element = {<Login/>}/>
      <Route path = "/home"  element = {<Home/>}/>   

       {/* <Route exact path = "/home"
         element = {
         <ProtectedRoute>
            <Home/>
         </ProtectedRoute>
        }/>  */}
        <Route path = "/checkout" element = {
          <ProtectedRoute>
          <Checkout/>
       </ProtectedRoute>
        }/>
        <Route path = "/payment" element = {
          <ProtectedRoute>
          <Payment/>
       </ProtectedRoute>
        }/>
        </Routes>
      </UserAuthContextProvider>
        </BrowserRouter>
    </div>
  );
}

export default App;
